import { render, staticRenderFns } from "./TabbedViewItem.vue?vue&type=template&id=d8f4c27a&scoped=true"
import script from "./TabbedViewItem.vue?vue&type=script&lang=js"
export * from "./TabbedViewItem.vue?vue&type=script&lang=js"
import style0 from "./TabbedViewItem.vue?vue&type=style&index=0&id=d8f4c27a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8f4c27a",
  null
  
)

export default component.exports